import React, { useEffect, useState } from "react";
import apiClient from "../../lib/api";
import { useI18n } from "../../i18n";
import { Link } from "react-router-dom";
import { ChevronRight, Search } from "lucide-react";

const STATUS_COLORS = {
  pending_payment: "bg-secondary-warm text-ink",
  paid: "bg-olive/20 text-olive",
  shipped: "bg-blue-100 text-blue-800",
  delivered: "bg-green-100 text-green-800",
  cancelled: "bg-red-100 text-red-800",
};

const AdminOrders = () => {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");

  useEffect(() => { apiClient.get("/admin/orders").then((r) => setItems(r.data)); }, []);

  const filtered = items.filter((o) => {
    if (filter !== "all" && o.status !== filter) return false;
    if (q && !o.order_id.toLowerCase().includes(q.toLowerCase()) && !o.email.toLowerCase().includes(q.toLowerCase())) return false;
    return true;
  });

  return (
    <div data-testid="admin-orders-page">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-light">{lang === "nl" ? "Bestellingen" : "Orders"}</h1>
        <div className="flex items-center gap-3">
          <div className="flex items-center bg-white border border-black/15 px-3 py-2">
            <Search className="w-4 h-4 text-ink-muted" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={lang === "nl" ? "Zoek order / e-mail" : "Search order / email"} className="bg-transparent outline-none px-2 text-sm w-56" data-testid="admin-orders-search" />
          </div>
          <select value={filter} onChange={(e) => setFilter(e.target.value)} className="border border-black/15 bg-white px-3 py-2 text-sm" data-testid="admin-orders-filter">
            <option value="all">{lang === "nl" ? "Alle" : "All"}</option>
            <option value="pending_payment">{lang === "nl" ? "Wachtend" : "Pending"}</option>
            <option value="paid">{lang === "nl" ? "Betaald" : "Paid"}</option>
            <option value="shipped">{lang === "nl" ? "Verzonden" : "Shipped"}</option>
            <option value="delivered">{lang === "nl" ? "Bezorgd" : "Delivered"}</option>
          </select>
        </div>
      </div>

      <div className="border border-black/10 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-secondary-warm text-left">
            <tr>
              <th className="px-4 py-3 font-label">Order</th>
              <th className="px-4 py-3 font-label">Email</th>
              <th className="px-4 py-3 font-label">{lang === "nl" ? "Betaling" : "Payment"}</th>
              <th className="px-4 py-3 font-label">Total</th>
              <th className="px-4 py-3 font-label">Status</th>
              <th className="px-4 py-3 font-label">Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-black/5">
            {filtered.map((o) => (
              <tr key={o.order_id} data-testid={`admin-order-row-${o.order_id}`} className="hover:bg-secondary-warm/40">
                <td className="px-4 py-3 font-display">{o.order_id}</td>
                <td className="px-4 py-3">{o.email}</td>
                <td className="px-4 py-3 text-xs uppercase">{o.payment_method}</td>
                <td className="px-4 py-3 font-display">€{o.grand_total.toFixed(2)}</td>
                <td className="px-4 py-3"><span className={`font-label px-2 py-1 ${STATUS_COLORS[o.status] || "bg-secondary-warm"}`}>{o.status}</span></td>
                <td className="px-4 py-3 text-xs text-ink-muted">{o.created_at?.slice(0, 16).replace("T", " ")}</td>
                <td className="px-4 py-3"><Link to={`/admin/orders/${o.order_id}`} className="text-ink-muted hover:text-ink" data-testid={`admin-order-detail-${o.order_id}`}><ChevronRight className="w-4 h-4" /></Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminOrders;
